import { HttpClientFactory } from '../services/HttpClientFactory';
import { ServicesContainer } from '../services/ServicesContainer';
import { atom, getDefaultStore, useAtomValue } from 'jotai';
import { ChatService as DsChatService } from '../services/ChatService';
import { DomainService } from '../services/DomainService';

const containerAtom = atom<ServicesContainer>();

export const initAppStore = () => {
  const store = getDefaultStore();
  const httpClientFactory = new HttpClientFactory(window.__BASEURL__);

  const chatServiceDs = new DsChatService(httpClientFactory.getDefaultClient());
  const domainService = new DomainService();

  store.set(containerAtom, {
    chatServiceDs,
    domainService,
  });
};

export const useServices = (): ServicesContainer => {
  return useAtomValue(containerAtom) as ServicesContainer;
};
